module.exports = __webpack_public_path__ + "static/media/user.9acfe78b.png";